import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
} from '@mui/material'
import * as React from 'react'
import { useEditSampleRun } from '../../APIs/Hooks/SampleRunHooks'
import { tsGetSampleRun } from '../../Typescript/API_Response'

function DialogDestroyRun({
  open,
  setOpen,
  sampleRun,
}: {
  open: boolean
  setOpen: any
  sampleRun: tsGetSampleRun | undefined
}) {
  const { mutate: editRunStatus } = useEditSampleRun(sampleRun, setOpen)

  return (
    <Dialog
      aria-label={'Destroy Run Dialog'}
      open={open}
      onClose={() => setOpen(false)}
    >
      <DialogTitle>{'Destroy Sample Run?'}</DialogTitle>
      <DialogContent>
        <DialogContentText>
          All included samples will also be destroyed. This procedure cannot be
          reversed, do want to continue?
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button
          onClick={() => setOpen(false)}
          color="warning"
        >
          Cancel
        </Button>
        <Button
          onClick={() => editRunStatus('DES')}
          color="error"
        >
          Destroy Sample Run
        </Button>
      </DialogActions>
    </Dialog>
  )
}

export default DialogDestroyRun
